// extracted by mini-css-extract-plugin
module.exports = {"header":"UserOverviewTab_header__2UPvP","headerWrapper":"UserOverviewTab_headerWrapper__2XDpr"};